import { SingleUserProfileSchema } from '../user/web';
export const EmployeeSchema = SingleUserProfileSchema;
